import ConfirmModalBase from 'cookie-banner/base/ConfirmModalBase'

export class TeachableConfirmModal extends ConfirmModalBase {
  override async loadCompanyStyle(): Promise<void> {
    await require('./style.css')
  }
}
